import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import {AppComponent} from "../../../app.component";
import {FormControl, FormGroup} from "@angular/forms";
import {User} from "../../../objects/user";
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-game-proposal-component',
  templateUrl: './game-proposal-component.component.html',
  styleUrls: []
})
export class GameProposalComponentComponent implements OnInit {
  @HostListener('document:keydown', ['$event'])
  public onKeyDown($event: KeyboardEvent) {
    $event.stopPropagation();
    if ($event.key === 'Enter') {
      this.handleSubmit()
    }
  }

  @Input() application: AppComponent;
  @Input() payload: object;
  @Output() close = new EventEmitter<void>();
  @Output() success = new EventEmitter<void>();

  profile: User
  isTrainer: boolean = false
  iAmAlsoTrainer: boolean = false
  isPlayable: boolean = false

  public componentForm: FormGroup = new FormGroup({
    game_option: new FormControl()
  });

  constructor() {
  }

  ngOnInit(): void {
    this.profile = this.payload['profile'];
    this.isPlayable = User.checkProfilesForGame(this.application.user,this.profile);
    this.isTrainer = User.isTrainer(this.profile);
    this.iAmAlsoTrainer = User.isTrainer(this.application.user);
    if(this.isTrainer) {
      this.componentForm.get('game_option').setValue('option_1');
    } else {
      this.componentForm.get('game_option').setValue('option_2');
    }
    console.log('checkProfileForGame',User.checkProfilesForGame(this.application.user,this.profile))
  }

  public onNoClick(): void {
    //this.dialogRef.close({ isConfirmed: false });
    this.close.emit()
  }

  public handleSubmit(event: Event | void = null): void {
    if (event) {
      event.stopPropagation();
    }

    if(!environment['mobile_exit_strategy']) {
      window.alert('missing mobile_exit_strategy');
      return;
    }

    if(environment['mobile_exit_strategy'] === 'viber') {
      if(this.componentForm.get('game_option').value === 'option_1') {
        let exit_context = '__trainer_preview_'+this.profile.id;
        window.open(environment['viber_url']+exit_context)
      }
      if(this.componentForm.get('game_option').value === 'option_2') {
        let exit_context = '__club_player_confirm_game_'+this.profile.id+'_'+this.profile['sig'];
        window.open(environment['viber_url']+exit_context)
      }
      if(this.componentForm.get('game_option').value === 'option_3') { //if iAmAlsoTrainer, after game confirmation - game will be converted to trainer_booking_add event and reflected in trainer's schedule
        let exit_context = '__club_player_call_to_game_'+this.profile.id+'_'+this.profile['sig'];
        window.open(environment['viber_url']+exit_context)
      }
    }
  }
}
